import { useQuery } from "react-query";

import { fetchFindingCounts } from "@api";
import { useOrg } from "@hooks/useOrg";
import { useTimeLookbackRange } from "@hooks/useTimeLookbackRange";
import { timeLookbackRangeToSince } from "@utils";

/*
 * This hook returns the total count of findings for the current org
 */
export const useTotalFindingCounts = (dedup?: boolean) => {
  const org = useOrg();
  const { tlr } = useTimeLookbackRange();

  const search = new URLSearchParams();

  search.set("dedup", `${Boolean(dedup)}`);
  if (tlr) {
    search.set("since", String(timeLookbackRangeToSince(tlr)));
  }

  return useQuery(
    ["TotalFindingCounts", { org }, tlr, dedup],
    () => fetchFindingCounts(org?.id!, search),
    { enabled: !!org && !!tlr && dedup !== undefined }
  );
};
